import Card from '../../../components/Card';
import { Tab, TabBody, TabHeader, Tabs } from '../../../components/Tabs';
import useWidth from '../../../hooks/useWidth';
import GlobalTradeHistory from '../ExchangeHistory/GlobalTradeHistory';
import Orders from './Orders';
import Positions from './Positions';
import Trades from './Trades';
import { useState, useEffect } from 'react';

const ROW_PER_PAGE = 6;

const ExchangeLists = () => {
    const [tabIndex, setTabIndex] = useState(0);

    const windowWidth = useWidth();

    useEffect(() => {
        if (windowWidth <= 768 && tabIndex === 3) {
            setTabIndex(0);
        }
    }, [tabIndex, windowWidth]);

    return (
        <div className='exchange-lists'>
            <Card>
                <Tabs tabIndex={tabIndex} setTabIndex={setTabIndex}>
                    <TabHeader>
                        <Tab>Positions</Tab>
                        <Tab>Orders</Tab>
                        <Tab>Trades</Tab>
                        <Tab>Global Trade History</Tab>
                    </TabHeader>
                    <TabBody>
                        <Positions rowPerPage={ROW_PER_PAGE} />
                        <Orders rowPerPage={ROW_PER_PAGE} />
                        <Trades rowPerPage={ROW_PER_PAGE} />
                        <GlobalTradeHistory />
                    </TabBody>
                </Tabs>
            </Card>
        </div>
    );
};

export default ExchangeLists;
